import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import Login from './components/auth/Login';
import AdminDashboard from './components/admin/AdminDashboard';
import PriceList from './components/admin/PriceList';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoadingSpinner from './components/common/LoadingSpinner';
import NotificationToast from './components/common/NotificationToast';
import ErrorBoundary from './components/common/ErrorBoundary';
import { validateToken } from './utils/authUtils';
import './App.css';

function App() {
  useEffect(() => {
    // Check token validity on app startup
    const token = localStorage.getItem('token');
    if (token && !validateToken()) {
      console.log('Token expired on app startup, clearing authentication');
      localStorage.removeItem('token');
      localStorage.removeItem('role');
    }
  }, []);

  return (
    <Provider store={store}>
      <ErrorBoundary>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<Login />} />
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/prices" 
                element={
                  <ProtectedRoute>
                    <PriceList />
                  </ProtectedRoute>
                } 
              />
            </Routes>
            <LoadingSpinner />
            <NotificationToast />
          </div>
        </Router>
      </ErrorBoundary>
    </Provider>
  );
}

export default App;